import { render } from "./AllUserView.vue?vue&type=template&id=47a1446f&scoped=true"
import script from "./AllUserView.vue?vue&type=script&lang=js"
export * from "./AllUserView.vue?vue&type=script&lang=js"

import "./AllUserView.vue?vue&type=style&index=0&id=47a1446f&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a1446f"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QInput,QIcon,QTd});
